package com.klantenstop.web.pages.admin.companies

import com.klantenstop.web.data.repos.CompanyRepo
import com.materialkobweb.utils.ViewModel
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class CompaniesViewModel(
    private val companyRepo: CompanyRepo = CompanyRepo
) : ViewModel(), CompaniesContract {

    private val _state = MutableStateFlow(CompaniesContract.State())
    override val state: StateFlow<CompaniesContract.State> = _state.asStateFlow()

    private val _effect = MutableSharedFlow<CompaniesContract.Effect>()
    override val effect: SharedFlow<CompaniesContract.Effect> = _effect.asSharedFlow()

    init {
        sendIntent(CompaniesContract.Intent.LoadCompanies)
    }

    override fun sendIntent(intent: CompaniesContract.Intent) = coroutineScope.launch {
        when (intent) {
            is CompaniesContract.Intent.LoadCompanies -> loadCompanies()
            is CompaniesContract.Intent.SearchCompanies -> searchCompanies(intent.query)
            is CompaniesContract.Intent.DeleteCompany -> deleteCompany(intent.companyId)
            is CompaniesContract.Intent.ChangePage -> changePage(intent.page)
            is CompaniesContract.Intent.ApproveCompany -> approveCompany(intent.companyId)
        }
    }

    override fun emitEffect(effect: CompaniesContract.Effect) = coroutineScope.launch {
        _effect.emit(effect)
    }

    override fun updateState(block: (CompaniesContract.State) -> CompaniesContract.State) {
        _state.update(block)
    }

    private suspend fun loadCompanies() {
        updateState { it.copy(isLoading = true) }

        // TODO: Implement load companies logic via companyRepo
        // val companies = companyRepo.getAllCompanies(page = state.value.currentPage)

        updateState {
            it.copy(
                // companies = companies,
                isLoading = false
            )
        }
    }

    private fun searchCompanies(query: String) {
        updateState { it.copy(searchQuery = query) }
        // TODO: Implement search filtering logic
    }

    private suspend fun deleteCompany(companyId: String) {
        updateState { it.copy(isLoading = true) }

        // TODO: Implement delete company logic
        // val success = companyRepo.deleteCompany(companyId)
        // if (success) {
        //     emitEffect(CompaniesContract.Effect.ShowSuccess("Company deleted successfully"))
        //     loadCompanies()
        // } else {
        //     emitEffect(CompaniesContract.Effect.ShowError("Failed to delete company"))
        // }

        updateState { it.copy(isLoading = false) }
    }

    private fun changePage(page: Int) {
        updateState { it.copy(currentPage = page) }
        sendIntent(CompaniesContract.Intent.LoadCompanies)
    }

    private suspend fun approveCompany(companyId: String) {
        updateState { it.copy(isLoading = true) }

        // TODO: Implement approve company logic
        // val success = companyRepo.approveCompany(companyId)
        // if (success) {
        //     emitEffect(CompaniesContract.Effect.ShowSuccess("Company approved successfully"))
        //     loadCompanies()
        // } else {
        //     emitEffect(CompaniesContract.Effect.ShowError("Failed to approve company"))
        // }

        updateState { it.copy(isLoading = false) }
    }
}

